var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _dec46, _dec47, _dec48, _dec49, _dec50, _dec51, _dec52, _dec53, _dec54, _dec55, _dec56, _dec57, _dec58, _dec59, _dec60, _dec61, _dec62, _dec63, _dec64, _dec65, _dec66, _dec67, _dec68, _dec69, _dec70, _dec71, _dec72, _dec73, _dec74, _dec75, _dec76, _dec77, _dec78, _dec79, _dec80, _dec81, _dec82, _dec83, _dec84, _dec85, _dec86, _dec87, _dec88, _dec89, _dec90, _dec91, _dec92, _dec93, _dec94, _dec95, _dec96, _dec97, _dec98, _dec99, _dec100, _dec101, _dec102, _dec103, _dec104, _dec105, _dec106, _dec107, _dec108, _dec109, _dec110, _dec111, _dec112, _dec113, _dec114, _dec115, _dec116, _dec117, _dec118, _dec119, _dec120, _dec121, _dec122, _dec123, _dec124, _dec125, _dec126, _dec127, _dec128, _dec129, _dec130, _dec131, _dec132, _dec133, _dec134, _dec135, _dec136, _dec137, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _descriptor52, _descriptor53, _descriptor54, _descriptor55, _descriptor56, _descriptor57, _descriptor58, _descriptor59, _descriptor60, _descriptor61, _descriptor62, _descriptor63, _descriptor64, _descriptor65, _descriptor66, _descriptor67, _descriptor68, _descriptor69, _descriptor70, _descriptor71, _descriptor72, _descriptor73, _descriptor74, _descriptor75, _descriptor76, _descriptor77, _descriptor78, _descriptor79, _descriptor80, _descriptor81, _descriptor82, _descriptor83, _descriptor84, _descriptor85, _descriptor86, _descriptor87, _descriptor88, _descriptor89, _descriptor90, _descriptor91, _descriptor92, _descriptor93, _descriptor94, _descriptor95, _descriptor96, _descriptor97, _descriptor98, _descriptor99, _descriptor100, _descriptor101, _descriptor102, _descriptor103, _descriptor104, _descriptor105, _descriptor106, _descriptor107, _descriptor108, _descriptor109, _descriptor110, _descriptor111, _descriptor112, _descriptor113, _descriptor114, _descriptor115, _descriptor116, _descriptor117, _descriptor118, _descriptor119, _descriptor120, _descriptor121, _descriptor122, _descriptor123, _descriptor124, _descriptor125, _descriptor126, _descriptor127, _descriptor128, _descriptor129, _descriptor130, _descriptor131, _descriptor132, _descriptor133, _descriptor134, _descriptor135, _descriptor136, _descriptor137, _descriptor138, _MedicalHistoryChangedJournalEvent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, belongsTo } from "@ember-data/model";
import { service } from "@ember/service";
import JournalEvent from "core/models/journal-event";
import Patient from "core/models/patient";
import Vaccine from "core/models/vaccine";
let MedicalHistoryChangedJournalEvent = (_dec = belongsTo("patient", {
  async: false,
  inverse: "medicalHistoryChangedJournalEvent"
}), _dec2 = attr("vaccines"), _dec3 = attr("string"), _dec4 = attr("date"), _dec5 = attr("date"), _dec6 = attr("string"), _dec7 = attr("string"), _dec8 = attr("string"), _dec9 = attr("string"), _dec10 = attr("string"), _dec11 = attr("boolean", {
  allowNull: true
}), _dec12 = attr("boolean", {
  allowNull: true
}), _dec13 = attr("string"), _dec14 = attr("string"), _dec15 = attr("boolean", {
  allowNull: true
}), _dec16 = attr("string"), _dec17 = attr("string"), _dec18 = attr("number"), _dec19 = attr("string"), _dec20 = attr("number"), _dec21 = attr("string"), _dec22 = attr("string"), _dec23 = attr("date"), _dec24 = attr("number"), _dec25 = attr("number"), _dec26 = attr("number"), _dec27 = attr("number"), _dec28 = attr("number"), _dec29 = attr("number"), _dec30 = attr("date"), _dec31 = attr("string"), _dec32 = attr("number"), _dec33 = attr("number"), _dec34 = attr("string"), _dec35 = attr("string"), _dec36 = attr("string"), _dec37 = attr("string"), _dec38 = attr("string"), _dec39 = attr("boolean"), _dec40 = attr("string"), _dec41 = attr("number"), _dec42 = attr("number"), _dec43 = attr("boolean"), _dec44 = attr("boolean"), _dec45 = attr("boolean"), _dec46 = attr("boolean"), _dec47 = attr("number"), _dec48 = attr("boolean"), _dec49 = attr("string"), _dec50 = attr("boolean"), _dec51 = attr("boolean"), _dec52 = attr("string"), _dec53 = attr("number"), _dec54 = attr("boolean"), _dec55 = attr("string"), _dec56 = attr("string"), _dec57 = attr("string"), _dec58 = attr("string"), _dec59 = attr("string"), _dec60 = attr("string"), _dec61 = attr("string"), _dec62 = attr("string"), _dec63 = attr("string"), _dec64 = attr("string"), _dec65 = attr("string"), _dec66 = attr("string"), _dec67 = attr("boolean", {
  allowNull: true
}), _dec68 = attr("string"), _dec69 = attr("string"), _dec70 = attr("string"), _dec71 = attr("number"), _dec72 = attr("string"), _dec73 = attr(), _dec74 = attr(), _dec75 = attr(), _dec76 = attr("string"), _dec77 = attr("boolean", {
  allowNull: true
}), _dec78 = attr("children", {
  defaultValue() {
    return [];
  }
}), _dec79 = attr("string"), _dec80 = attr("boolean", {
  allowNull: true
}), _dec81 = attr("boolean", {
  allowNull: true
}), _dec82 = attr("boolean", {
  allowNull: true
}), _dec83 = attr(), _dec84 = attr("boolean", {
  allowNull: true
}), _dec85 = attr(), _dec86 = attr("boolean", {
  allowNull: true
}), _dec87 = attr(), _dec88 = attr("boolean", {
  allowNull: true
}), _dec89 = attr(), _dec90 = attr("boolean", {
  allowNull: true
}), _dec91 = attr(), _dec92 = attr("boolean", {
  allowNull: true
}), _dec93 = attr("boolean", {
  allowNull: true
}), _dec94 = attr("string", {
  allowNull: true
}), _dec95 = attr("string", {
  allowNull: true
}), _dec96 = attr(), _dec97 = attr("boolean", {
  allowNull: true
}), _dec98 = attr("boolean", {
  allowNull: true
}), _dec99 = attr("boolean", {
  allowNull: true
}), _dec100 = attr("boolean", {
  allowNull: true
}), _dec101 = attr("string"), _dec102 = attr(), _dec103 = attr("boolean", {
  allowNull: true
}), _dec104 = attr("boolean", {
  allowNull: true
}), _dec105 = attr("boolean", {
  allowNull: true
}), _dec106 = attr(), _dec107 = attr("string"), _dec108 = attr(), _dec109 = attr("boolean", {
  allowNull: true
}), _dec110 = attr("string"), _dec111 = attr("number"), _dec112 = attr("string"), _dec113 = attr("boolean"), _dec114 = attr("date"), _dec115 = attr("string"), _dec116 = attr("string"), _dec117 = attr("date"), _dec118 = attr("string"), _dec119 = attr("date"), _dec120 = attr("string"), _dec121 = attr("date"), _dec122 = attr("string"), _dec123 = attr("date"), _dec124 = attr("string"), _dec125 = attr("date"), _dec126 = attr("string"), _dec127 = attr("date"), _dec128 = attr("string"), _dec129 = attr("date"), _dec130 = attr("string"), _dec131 = attr("date"), _dec132 = attr("string"), _dec133 = attr("date"), _dec134 = attr("string"), _dec135 = attr("date"), _dec136 = attr("string"), _dec137 = attr("date"), _class = (_MedicalHistoryChangedJournalEvent = class MedicalHistoryChangedJournalEvent extends JournalEvent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "patient", _descriptor, this);
    _initializerDefineProperty(this, "vaccines", _descriptor2, this);
    _initializerDefineProperty(this, "comments", _descriptor3, this);
    _initializerDefineProperty(this, "diagnosisDate", _descriptor4, this);
    // Nephrowise specific
    _initializerDefineProperty(this, "transplantDate", _descriptor5, this);
    _initializerDefineProperty(this, "transplantRank", _descriptor6, this);
    _initializerDefineProperty(this, "nephropatie", _descriptor7, this);
    _initializerDefineProperty(this, "underlyingDisease", _descriptor8, this);
    _initializerDefineProperty(this, "cytomegalovirusStatus", _descriptor9, this);
    _initializerDefineProperty(this, "donorType", _descriptor10, this);
    _initializerDefineProperty(this, "immunologicalRisk", _descriptor11, this);
    _initializerDefineProperty(this, "incompatibleAbo", _descriptor12, this);
    _initializerDefineProperty(this, "mrcStage", _descriptor13, this);
    _initializerDefineProperty(this, "hemodialysisType", _descriptor14, this);
    _initializerDefineProperty(this, "mrcPreexistingTransplant", _descriptor15, this);
    _initializerDefineProperty(this, "transplantedOrgan", _descriptor16, this);
    _initializerDefineProperty(this, "abmClassification", _descriptor17, this);
    _initializerDefineProperty(this, "creatinineThreeMonthsAfterTransplant", _descriptor18, this);
    _initializerDefineProperty(this, "donorCreatinine", _descriptor19, this);
    _initializerDefineProperty(this, "rejectsFirstYear", _descriptor20, this);
    _initializerDefineProperty(this, "heartFailureType", _descriptor21, this);
    _initializerDefineProperty(this, "nyhaStage", _descriptor22, this);
    _initializerDefineProperty(this, "diagnosticDate", _descriptor23, this);
    _initializerDefineProperty(this, "fevg", _descriptor24, this);
    _initializerDefineProperty(this, "state", _descriptor25, this);
    _initializerDefineProperty(this, "height", _descriptor26, this);
    _initializerDefineProperty(this, "weight", _descriptor27, this);
    _initializerDefineProperty(this, "year", _descriptor28, this);
    _initializerDefineProperty(this, "hba", _descriptor29, this);
    _initializerDefineProperty(this, "hbaDate", _descriptor30, this);
    _initializerDefineProperty(this, "mrc", _descriptor31, this);
    _initializerDefineProperty(this, "dfg", _descriptor32, this);
    _initializerDefineProperty(this, "rac", _descriptor33, this);
    _initializerDefineProperty(this, "reti", _descriptor34, this);
    _initializerDefineProperty(this, "neur", _descriptor35, this);
    _initializerDefineProperty(this, "mcva", _descriptor36, this);
    _initializerDefineProperty(this, "ic", _descriptor37, this);
    _initializerDefineProperty(this, "oth", _descriptor38, this);
    _initializerDefineProperty(this, "exp", _descriptor39, this);
    _initializerDefineProperty(this, "hta", _descriptor40, this);
    _initializerDefineProperty(this, "systolic", _descriptor41, this);
    _initializerDefineProperty(this, "diastolic", _descriptor42, this);
    _initializerDefineProperty(this, "met", _descriptor43, this);
    _initializerDefineProperty(this, "isglt2", _descriptor44, this);
    _initializerDefineProperty(this, "arglp1", _descriptor45, this);
    _initializerDefineProperty(this, "dyslipidemieTreated", _descriptor46, this);
    _initializerDefineProperty(this, "lastDyslipidemie", _descriptor47, this);
    _initializerDefineProperty(this, "smoker", _descriptor48, this);
    _initializerDefineProperty(this, "doSport", _descriptor49, this);
    _initializerDefineProperty(this, "insulin", _descriptor50, this);
    _initializerDefineProperty(this, "idpp4", _descriptor51, this);
    _initializerDefineProperty(this, "familyIcBackground", _descriptor52, this);
    _initializerDefineProperty(this, "albuminuria", _descriptor53, this);
    _initializerDefineProperty(this, "isFollowingDiabetologist", _descriptor54, this);
    _initializerDefineProperty(this, "registrationTransplantWaitingList", _descriptor55, this);
    _initializerDefineProperty(this, "assessmentRealisation", _descriptor56, this);
    _initializerDefineProperty(this, "assessmentResult", _descriptor57, this);
    _initializerDefineProperty(this, "professionalActivity", _descriptor58, this);
    _initializerDefineProperty(this, "housing", _descriptor59, this);
    _initializerDefineProperty(this, "lifestyle", _descriptor60, this);
    _initializerDefineProperty(this, "diseaseActivity", _descriptor61, this);
    _initializerDefineProperty(this, "diagnosticType", _descriptor62, this);
    // Oncowise specific
    _initializerDefineProperty(this, "session", _descriptor63, this);
    _initializerDefineProperty(this, "side", _descriptor64, this);
    _initializerDefineProperty(this, "stage", _descriptor65, this);
    _initializerDefineProperty(this, "histology", _descriptor66, this);
    _initializerDefineProperty(this, "her2", _descriptor67, this);
    _initializerDefineProperty(this, "fertilityPreservation", _descriptor68, this);
    _initializerDefineProperty(this, "oncogeneticConsultation", _descriptor69, this);
    _initializerDefineProperty(this, "tnmComment", _descriptor70, this);
    _initializerDefineProperty(this, "pelvicSonogram", _descriptor71, this);
    _initializerDefineProperty(this, "ki67", _descriptor72, this);
    _initializerDefineProperty(this, "hematoCancerType", _descriptor73, this);
    _initializerDefineProperty(this, "tnmClassification", _descriptor74, this);
    _initializerDefineProperty(this, "estrogenReceptor", _descriptor75, this);
    _initializerDefineProperty(this, "progesteroneReceptor", _descriptor76, this);
    _initializerDefineProperty(this, "maritalStatus", _descriptor77, this);
    _initializerDefineProperty(this, "hasChildren", _descriptor78, this);
    _initializerDefineProperty(this, "children", _descriptor79, this);
    _initializerDefineProperty(this, "job", _descriptor80, this);
    _initializerDefineProperty(this, "relapse", _descriptor81, this);
    _initializerDefineProperty(this, "tripleNegative", _descriptor82, this);
    _initializerDefineProperty(this, "familyHistoryBreastCancer", _descriptor83, this);
    _initializerDefineProperty(this, "familyHistoryBreastCancerMember", _descriptor84, this);
    _initializerDefineProperty(this, "familyHistoryOvarianCancer", _descriptor85, this);
    _initializerDefineProperty(this, "familyHistoryOvarianCancerMember", _descriptor86, this);
    _initializerDefineProperty(this, "brca1", _descriptor87, this);
    _initializerDefineProperty(this, "brca1Member", _descriptor88, this);
    _initializerDefineProperty(this, "brca2", _descriptor89, this);
    _initializerDefineProperty(this, "brca2Member", _descriptor90, this);
    _initializerDefineProperty(this, "otherCancer", _descriptor91, this);
    _initializerDefineProperty(this, "otherCancerType", _descriptor92, this);
    _initializerDefineProperty(this, "menopause", _descriptor93, this);
    _initializerDefineProperty(this, "contraception", _descriptor94, this);
    _initializerDefineProperty(this, "cellCancerType", _descriptor95, this);
    _initializerDefineProperty(this, "nonSmallCellCancerType", _descriptor96, this);
    _initializerDefineProperty(this, "mutation", _descriptor97, this);
    _initializerDefineProperty(this, "statutPDL1", _descriptor98, this);
    _initializerDefineProperty(this, "smokingPatients", _descriptor99, this);
    _initializerDefineProperty(this, "lungCancerFamily", _descriptor100, this);
    _initializerDefineProperty(this, "chronicBronchopneumopathy", _descriptor101, this);
    _initializerDefineProperty(this, "pancreaticCancerType", _descriptor102, this);
    _initializerDefineProperty(this, "pancreaticMutation", _descriptor103, this);
    _initializerDefineProperty(this, "familialPancreaticCancer", _descriptor104, this);
    _initializerDefineProperty(this, "hereditaryChronicPrss1GeneMutation", _descriptor105, this);
    _initializerDefineProperty(this, "familyHistoryProstateCancer", _descriptor106, this);
    _initializerDefineProperty(this, "familyHistoryProstateCancerMember", _descriptor107, this);
    _initializerDefineProperty(this, "prostateCancerType", _descriptor108, this);
    _initializerDefineProperty(this, "prostateMutations", _descriptor109, this);
    _initializerDefineProperty(this, "hormoneSensitiveCancer", _descriptor110, this);
    _initializerDefineProperty(this, "gleasonScore", _descriptor111, this);
    // Mentalwise specific
    _initializerDefineProperty(this, "numberOfTs", _descriptor112, this);
    _initializerDefineProperty(this, "mainDiagnosis", _descriptor113, this);
    _initializerDefineProperty(this, "suicideRisk", _descriptor114, this);
    _initializerDefineProperty(this, "suicidalThoughtsStartDate", _descriptor115, this);
    // Rhumatowise specific
    _initializerDefineProperty(this, "prType", _descriptor116, this);
    _initializerDefineProperty(this, "boneErosion", _descriptor117, this);
    _initializerDefineProperty(this, "erosionDiagnosisDate", _descriptor118, this);
    _initializerDefineProperty(this, "facteurRhumatoidesValue", _descriptor119, this);
    _initializerDefineProperty(this, "facteurRhumatoidesDate", _descriptor120, this);
    _initializerDefineProperty(this, "antiCppValue", _descriptor121, this);
    _initializerDefineProperty(this, "antiCppDate", _descriptor122, this);
    _initializerDefineProperty(this, "anticorpsAntiNucleairesValue", _descriptor123, this);
    _initializerDefineProperty(this, "anticorpsAntiNucleairesDate", _descriptor124, this);
    _initializerDefineProperty(this, "serologieHivValue", _descriptor125, this);
    _initializerDefineProperty(this, "serologieHivDate", _descriptor126, this);
    _initializerDefineProperty(this, "antigeneHbsValue", _descriptor127, this);
    _initializerDefineProperty(this, "antigeneHbsDate", _descriptor128, this);
    _initializerDefineProperty(this, "anticorpsAntiHbsValue", _descriptor129, this);
    _initializerDefineProperty(this, "anticorpsAntiHbsDate", _descriptor130, this);
    _initializerDefineProperty(this, "anticorpsAntiHbcValue", _descriptor131, this);
    _initializerDefineProperty(this, "anticorpsAntiHbcDate", _descriptor132, this);
    _initializerDefineProperty(this, "serologieHepatiteCValue", _descriptor133, this);
    _initializerDefineProperty(this, "serologieHepatiteCDate", _descriptor134, this);
    _initializerDefineProperty(this, "electropheresValue", _descriptor135, this);
    _initializerDefineProperty(this, "electropheresDate", _descriptor136, this);
    _initializerDefineProperty(this, "quantiferonValue", _descriptor137, this);
    _initializerDefineProperty(this, "quantiferonDate", _descriptor138, this);
  }
  get hormoneReceptors() {
    if (!this.estrogenReceptor || !this.progesteroneReceptor) {
      return undefined;
    }
    const estrogenReceptor = this.estrogenReceptor;
    const progesteroneReceptor = this.progesteroneReceptor;
    function isEstrogenPositive() {
      return estrogenReceptor && estrogenReceptor.percentage > 0;
    }
    function isProgesteronePositive() {
      return progesteroneReceptor && progesteroneReceptor.percentage > 0;
    }
    function isEstrogenNegative() {
      return estrogenReceptor && estrogenReceptor.percentage == 0;
    }
    function isProgesteroneNegative() {
      return progesteroneReceptor && progesteroneReceptor.percentage == 0;
    }

    // If at least on receptor > 0 then positive
    if (isEstrogenPositive() || isProgesteronePositive()) {
      return "positive";
    }
    // If the two receptors === 0 then negative
    else if (isEstrogenNegative() && isProgesteroneNegative()) {
      return "negative";
    }
    return undefined;
  }
}, _defineProperty(_MedicalHistoryChangedJournalEvent, "type", "medical-history-changed-journal-event"), _MedicalHistoryChangedJournalEvent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "patient", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "vaccines", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "comments", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "diagnosisDate", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "transplantDate", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "transplantRank", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "nephropatie", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "underlyingDisease", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "cytomegalovirusStatus", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "donorType", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "immunologicalRisk", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "incompatibleAbo", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "mrcStage", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "hemodialysisType", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "mrcPreexistingTransplant", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "transplantedOrgan", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "abmClassification", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "creatinineThreeMonthsAfterTransplant", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "donorCreatinine", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "rejectsFirstYear", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "heartFailureType", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "nyhaStage", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "diagnosticDate", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "fevg", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "state", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "height", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "weight", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "year", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "hba", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "hbaDate", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "mrc", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "dfg", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "rac", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "reti", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "neur", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "mcva", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "ic", [_dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "oth", [_dec38], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "exp", [_dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "hta", [_dec40], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "systolic", [_dec41], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "diastolic", [_dec42], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "met", [_dec43], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "isglt2", [_dec44], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "arglp1", [_dec45], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "dyslipidemieTreated", [_dec46], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "lastDyslipidemie", [_dec47], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "smoker", [_dec48], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "doSport", [_dec49], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor50 = _applyDecoratedDescriptor(_class.prototype, "insulin", [_dec50], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor51 = _applyDecoratedDescriptor(_class.prototype, "idpp4", [_dec51], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor52 = _applyDecoratedDescriptor(_class.prototype, "familyIcBackground", [_dec52], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor53 = _applyDecoratedDescriptor(_class.prototype, "albuminuria", [_dec53], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor54 = _applyDecoratedDescriptor(_class.prototype, "isFollowingDiabetologist", [_dec54], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor55 = _applyDecoratedDescriptor(_class.prototype, "registrationTransplantWaitingList", [_dec55], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor56 = _applyDecoratedDescriptor(_class.prototype, "assessmentRealisation", [_dec56], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor57 = _applyDecoratedDescriptor(_class.prototype, "assessmentResult", [_dec57], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor58 = _applyDecoratedDescriptor(_class.prototype, "professionalActivity", [_dec58], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor59 = _applyDecoratedDescriptor(_class.prototype, "housing", [_dec59], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor60 = _applyDecoratedDescriptor(_class.prototype, "lifestyle", [_dec60], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor61 = _applyDecoratedDescriptor(_class.prototype, "diseaseActivity", [_dec61], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor62 = _applyDecoratedDescriptor(_class.prototype, "diagnosticType", [_dec62], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor63 = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor64 = _applyDecoratedDescriptor(_class.prototype, "side", [_dec63], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor65 = _applyDecoratedDescriptor(_class.prototype, "stage", [_dec64], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor66 = _applyDecoratedDescriptor(_class.prototype, "histology", [_dec65], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor67 = _applyDecoratedDescriptor(_class.prototype, "her2", [_dec66], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor68 = _applyDecoratedDescriptor(_class.prototype, "fertilityPreservation", [_dec67], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor69 = _applyDecoratedDescriptor(_class.prototype, "oncogeneticConsultation", [_dec68], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor70 = _applyDecoratedDescriptor(_class.prototype, "tnmComment", [_dec69], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor71 = _applyDecoratedDescriptor(_class.prototype, "pelvicSonogram", [_dec70], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor72 = _applyDecoratedDescriptor(_class.prototype, "ki67", [_dec71], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor73 = _applyDecoratedDescriptor(_class.prototype, "hematoCancerType", [_dec72], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor74 = _applyDecoratedDescriptor(_class.prototype, "tnmClassification", [_dec73], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor75 = _applyDecoratedDescriptor(_class.prototype, "estrogenReceptor", [_dec74], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor76 = _applyDecoratedDescriptor(_class.prototype, "progesteroneReceptor", [_dec75], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor77 = _applyDecoratedDescriptor(_class.prototype, "maritalStatus", [_dec76], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor78 = _applyDecoratedDescriptor(_class.prototype, "hasChildren", [_dec77], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor79 = _applyDecoratedDescriptor(_class.prototype, "children", [_dec78], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor80 = _applyDecoratedDescriptor(_class.prototype, "job", [_dec79], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor81 = _applyDecoratedDescriptor(_class.prototype, "relapse", [_dec80], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor82 = _applyDecoratedDescriptor(_class.prototype, "tripleNegative", [_dec81], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor83 = _applyDecoratedDescriptor(_class.prototype, "familyHistoryBreastCancer", [_dec82], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor84 = _applyDecoratedDescriptor(_class.prototype, "familyHistoryBreastCancerMember", [_dec83], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor85 = _applyDecoratedDescriptor(_class.prototype, "familyHistoryOvarianCancer", [_dec84], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor86 = _applyDecoratedDescriptor(_class.prototype, "familyHistoryOvarianCancerMember", [_dec85], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor87 = _applyDecoratedDescriptor(_class.prototype, "brca1", [_dec86], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor88 = _applyDecoratedDescriptor(_class.prototype, "brca1Member", [_dec87], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor89 = _applyDecoratedDescriptor(_class.prototype, "brca2", [_dec88], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor90 = _applyDecoratedDescriptor(_class.prototype, "brca2Member", [_dec89], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor91 = _applyDecoratedDescriptor(_class.prototype, "otherCancer", [_dec90], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor92 = _applyDecoratedDescriptor(_class.prototype, "otherCancerType", [_dec91], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor93 = _applyDecoratedDescriptor(_class.prototype, "menopause", [_dec92], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor94 = _applyDecoratedDescriptor(_class.prototype, "contraception", [_dec93], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor95 = _applyDecoratedDescriptor(_class.prototype, "cellCancerType", [_dec94], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor96 = _applyDecoratedDescriptor(_class.prototype, "nonSmallCellCancerType", [_dec95], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor97 = _applyDecoratedDescriptor(_class.prototype, "mutation", [_dec96], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor98 = _applyDecoratedDescriptor(_class.prototype, "statutPDL1", [_dec97], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor99 = _applyDecoratedDescriptor(_class.prototype, "smokingPatients", [_dec98], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor100 = _applyDecoratedDescriptor(_class.prototype, "lungCancerFamily", [_dec99], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor101 = _applyDecoratedDescriptor(_class.prototype, "chronicBronchopneumopathy", [_dec100], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor102 = _applyDecoratedDescriptor(_class.prototype, "pancreaticCancerType", [_dec101], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor103 = _applyDecoratedDescriptor(_class.prototype, "pancreaticMutation", [_dec102], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor104 = _applyDecoratedDescriptor(_class.prototype, "familialPancreaticCancer", [_dec103], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor105 = _applyDecoratedDescriptor(_class.prototype, "hereditaryChronicPrss1GeneMutation", [_dec104], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor106 = _applyDecoratedDescriptor(_class.prototype, "familyHistoryProstateCancer", [_dec105], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor107 = _applyDecoratedDescriptor(_class.prototype, "familyHistoryProstateCancerMember", [_dec106], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor108 = _applyDecoratedDescriptor(_class.prototype, "prostateCancerType", [_dec107], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor109 = _applyDecoratedDescriptor(_class.prototype, "prostateMutations", [_dec108], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor110 = _applyDecoratedDescriptor(_class.prototype, "hormoneSensitiveCancer", [_dec109], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor111 = _applyDecoratedDescriptor(_class.prototype, "gleasonScore", [_dec110], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor112 = _applyDecoratedDescriptor(_class.prototype, "numberOfTs", [_dec111], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor113 = _applyDecoratedDescriptor(_class.prototype, "mainDiagnosis", [_dec112], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor114 = _applyDecoratedDescriptor(_class.prototype, "suicideRisk", [_dec113], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor115 = _applyDecoratedDescriptor(_class.prototype, "suicidalThoughtsStartDate", [_dec114], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor116 = _applyDecoratedDescriptor(_class.prototype, "prType", [_dec115], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor117 = _applyDecoratedDescriptor(_class.prototype, "boneErosion", [_dec116], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor118 = _applyDecoratedDescriptor(_class.prototype, "erosionDiagnosisDate", [_dec117], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor119 = _applyDecoratedDescriptor(_class.prototype, "facteurRhumatoidesValue", [_dec118], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor120 = _applyDecoratedDescriptor(_class.prototype, "facteurRhumatoidesDate", [_dec119], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor121 = _applyDecoratedDescriptor(_class.prototype, "antiCppValue", [_dec120], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor122 = _applyDecoratedDescriptor(_class.prototype, "antiCppDate", [_dec121], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor123 = _applyDecoratedDescriptor(_class.prototype, "anticorpsAntiNucleairesValue", [_dec122], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor124 = _applyDecoratedDescriptor(_class.prototype, "anticorpsAntiNucleairesDate", [_dec123], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor125 = _applyDecoratedDescriptor(_class.prototype, "serologieHivValue", [_dec124], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor126 = _applyDecoratedDescriptor(_class.prototype, "serologieHivDate", [_dec125], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor127 = _applyDecoratedDescriptor(_class.prototype, "antigeneHbsValue", [_dec126], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor128 = _applyDecoratedDescriptor(_class.prototype, "antigeneHbsDate", [_dec127], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor129 = _applyDecoratedDescriptor(_class.prototype, "anticorpsAntiHbsValue", [_dec128], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor130 = _applyDecoratedDescriptor(_class.prototype, "anticorpsAntiHbsDate", [_dec129], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor131 = _applyDecoratedDescriptor(_class.prototype, "anticorpsAntiHbcValue", [_dec130], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor132 = _applyDecoratedDescriptor(_class.prototype, "anticorpsAntiHbcDate", [_dec131], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor133 = _applyDecoratedDescriptor(_class.prototype, "serologieHepatiteCValue", [_dec132], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor134 = _applyDecoratedDescriptor(_class.prototype, "serologieHepatiteCDate", [_dec133], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor135 = _applyDecoratedDescriptor(_class.prototype, "electropheresValue", [_dec134], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor136 = _applyDecoratedDescriptor(_class.prototype, "electropheresDate", [_dec135], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor137 = _applyDecoratedDescriptor(_class.prototype, "quantiferonValue", [_dec136], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor138 = _applyDecoratedDescriptor(_class.prototype, "quantiferonDate", [_dec137], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { MedicalHistoryChangedJournalEvent as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your models.